// Fokusfalle für modale Fenster: Tab/Umschalt+Tab bleiben im Fenster (Tastatur- und Screenreader-Bedienung).
const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export function trapFocus(node: HTMLElement) {
  const prev = document.activeElement as HTMLElement | null;
  function onKey(e: KeyboardEvent) {
    if (e.key !== 'Tab') return;
    const els = [...node.querySelectorAll<HTMLElement>(FOCUSABLE)].filter((el) => el.offsetParent !== null || el === document.activeElement);
    if (!els.length) return;
    const first = els[0];
    const last = els[els.length - 1];
    const inside = node.contains(document.activeElement);
    if (e.shiftKey && (document.activeElement === first || !inside)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && (document.activeElement === last || !inside)) {
      e.preventDefault();
      first.focus();
    }
  }
  // ein Lauscher am Dokument genügt: greift auch, wenn der Fokus noch außerhalb liegt (z. B. auf dem Seitenkörper)
  document.addEventListener('keydown', onKey);
  return {
    destroy() {
      document.removeEventListener('keydown', onKey);
      // Fokus an den Ausgangspunkt zurückgeben
      if (prev && document.contains(prev)) prev.focus?.();
    },
  };
}
